class BaoProductRecommendations extends HTMLElement {
  constructor () {
    super()

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return
      observer.unobserve(this)

      // Stop if there is no product
      if (this.dataset.url.includes('product_id=&')) return

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div')
          html.innerHTML = text
          const recommendations = html.querySelector('bao-product-recommendations')
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML
          }
        })
        .catch(e => {
          console.error(e)
        })
    }
    /* eslint-disable-next-line compat/compat */
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: '200px 0px 0px 0px',
    }).observe(this)
  }

  get baseUrl () {
    return this.dataset.baseUrl
  }

  get limit () {
    return this.dataset.limit
  }

  get productId () {
    return this.dataset.productId
  }

  get intent () {
    return this.dataset.intent
  }

  get sectionId () {
    return this.dataset.sectionId
  }
}

if (!customElements.get('bao-product-recommendations')) {
  customElements.define('bao-product-recommendations', BaoProductRecommendations)
}
